import React from "react";
import A_SimpleDialog from "../../../../../Atoms/Feedback/Dialogs/A_SimpleDialog";
import A_TextField from "../../../../../Atoms/Inputs/TextFields/A_TextField";
import A_Button from "../../../../../Atoms/Inputs/Buttons/A_Button";
import { Box } from "@material-ui/core";
import { getCRMContactInfo } from "../../../../../../../Utils/Helpers/common";
import { httpPost, httpPut } from "../../../../../../../Utils/apis/apis";
import PropTypes from "prop-types";

const OffboardClient = (props) => {
  const [comments, setComments] = React.useState("");
  const [isDialogOpen, setIsDialogOpen] = React.useState(true);
  let { crmContactUserName, crmContactUserEmail } = getCRMContactInfo();

  const handleOnChange = (event) => {
    setComments(event.target.value);
  };
  const security = {
    read: {
      groupids: [""],
      users: [""],
    },
    update: {
      groupids: [""],
      users: [""],
    },
    full: {
      groupids: [""],
      users: [],
    },
    privateRecord: false,
  };
  let pageUrl = props?.pageUrl;
  const handleSave = async () => {
    let dataObj = {
      ClientId: props?.crmId,
      comment: comments,
      clientOffboard: true,
      UserName: crmContactUserName,
      userEmail: crmContactUserEmail,
    };
    let payload = {
      spName: "InsertOffboard",
      parameters: {},
      parametersAsJsonString: JSON.stringify(dataObj),
    };
    let updatedData = {
      id: props?.crmId,
      label: pageUrl,
      properties: { comment: comments, clientOffboard: true },
      security: security,
      edges: [],
    };

    let crmResponse = await httpPut(
      `/CRMData/${"update"}?pageUrl=${pageUrl}`,
      updatedData,
      {},
      true
    );
    let sqlResponse = await httpPost(
      `/SQLBasedForm/SQLFormOperations`,
      payload,
      "",
      true
    );
    setIsDialogOpen(false);
    if (crmResponse?.statusText === "OK" || sqlResponse?.statusText === "OK") {
      props?.setChangesSaved({
        status: true,
        type: "success",
        msg: "Update Successfully",
      });
    } else {
      props?.setChangesSaved({
        status: true,
        type: "error",
        msg: "Something went wrong",
      });
    }

    setTimeout(location.reload.bind(location), 1000);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    props.setShowOffboardClient(false);
  };

  return (
    <>
      <A_SimpleDialog
        open={isDialogOpen}
        title="Client Offboard"
        fullScreen={false}
        height="200px"
        fullwidth={false}
        maxWidth={"xs"}
        onClose={handleCloseDialog}
        dialogActions={
          <Box display="flex" justifyContent="flex-end">
            <A_Button
              label="Save"
              onClick={handleSave}
              color={"primary"}
              disabled={comments.trim() === ""}
            />
          </Box>
        }
        dialogContent={
          <A_TextField
            label={"Comments *"}
            fullWidth={true}
            onChange={handleOnChange}
            value={comments}
            variant="standard"
          />
        }
      />
    </>
  );
};

OffboardClient.propTypes = {
  setShowOffboardClient: PropTypes.func,
  crmId: PropTypes.any,
  pageUrl: PropTypes.any,
  setChangesSaved: PropTypes.any,
};

export default React.memo(OffboardClient);
